import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { EMAIL } from "../data/content";

export const CtaBanner = ({
  title = "Let's Build Something That Matters.",
  text = "Tell us what you're working on. We'll start with the problem — then explore the right technology.",
}) => (
  <section className="relative py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div
          className="card-gradient relative overflow-hidden rounded-2xl border border-white/10 px-8 py-14 sm:px-14 lg:px-20 lg:py-20"
          data-testid="cta-banner"
        >
          <div className="bg-grid pointer-events-none absolute inset-0 opacity-50" />
          <div
            className="pointer-events-none absolute -top-40 left-1/2 h-80 w-[42rem] -translate-x-1/2 rounded-full blur-3xl"
            style={{ background: "radial-gradient(closest-side, rgb(195 79 45 / 0.16), transparent)" }}
          />
          <div className="relative">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-cyan-400">
              Start a conversation
            </p>
            <h2 className="mt-5 max-w-2xl font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-white leading-[1.12]">
              {title}
            </h2>
            <p className="mt-5 max-w-xl text-base text-slate-400 leading-relaxed">{text}</p>
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <Link
                to="/contact"
                data-testid="cta-start-project-btn"
                className="spark-gradient group inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-display text-sm font-semibold text-white transition-transform duration-300 hover:scale-[1.03]"
              >
                Start a Project
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <a
                href={`mailto:${EMAIL}`}
                data-testid="cta-email-link"
                className="inline-flex items-center gap-2 rounded-full border border-white/15 px-7 py-3.5 font-display text-sm font-semibold text-slate-200 transition-colors duration-300 hover:border-cyan-400/50 hover:text-white"
              >
                <Mail className="h-4 w-4 text-cyan-400" />
                {EMAIL}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
